function closeConsentDialog(ref) {
  const instance = ref.getWrappedInstance();
  return instance.dialog.closeDialog();
}

export default closeConsentDialog;
